import React from 'react';
import { useTranslation } from 'react-i18next';

import { getDay, getMonthYear } from 'utils/dateUtils';
import { submissionStatuses } from 'utils/constants/submissionConstants';

const StatusDecal = ({ date, status }) => {
  const { t } = useTranslation();
  const isBlackBoxItem = status === 'bb';

  const getStatusColor = status => submissionStatuses[status]?.color || 'none';
  const getStatusText = status => t(submissionStatuses[status]?.text || '');

  return (
    <div
      className={`status${
        status && status !== 'AWAITING_ARRIVAL'
          ? ` status--${getStatusColor(status)}`
          : ' status--none'
      } ${isBlackBoxItem ? 'dotted dotted--inverse' : ''}`}
    >
      {!isBlackBoxItem && (
        <>
          <div className="status__date">
            <span className={`status__day${status !== '' ? ' compact' : ''}`}>
              {getDay(date)}
            </span>
            <span className="status__monthyear">{getMonthYear(date)}</span>
          </div>
          {status && status !== 'AWAITING_ARRIVAL' && (
            <span className="status__text">{getStatusText(status)}</span>
          )}
        </>
      )}
    </div>
  );
};

export default StatusDecal;
